import { render, staticRenderFns } from "./AutopsyTab.vue?vue&type=template&id=e4433bc4&scoped=true"
import script from "./AutopsyTab.vue?vue&type=script&lang=js"
export * from "./AutopsyTab.vue?vue&type=script&lang=js"
import style0 from "./AutopsyTab.vue?vue&type=style&index=0&id=e4433bc4&prod&scoped=true&lang=css"
import style1 from "./AutopsyTab.vue?vue&type=style&index=1&id=e4433bc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4433bc4",
  null
  
)

export default component.exports